"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResult = void 0;
class SearchResult {
    constructor(words, suggestions, elapsedTime) {
        this.sizePerPage = 30;
        this.words = words;
        this.suggestions = suggestions;
        this.elapsedTime = elapsedTime;
    }
    static createEmpty() {
        const words = new Array();
        const suggestions = new Array();
        const elapsedTime = 0;
        const result = new SearchResult(words, suggestions, elapsedTime);
        return result;
    }
    static measure(search) {
        const beforeDate = new Date();
        const [words, suggestions] = search();
        const afterDate = new Date();
        const elapsedTime = afterDate.getTime() - beforeDate.getTime();
        const result = new SearchResult(words, suggestions, elapsedTime);
        return result;
    }
    copy() {
        const result = new SearchResult(this.words, this.suggestions, this.elapsedTime);
        return result;
    }
    sliceWords(page) {
        const words = this.words.slice(page * this.sizePerPage, page * this.sizePerPage + this.sizePerPage);
        return words;
    }
    get minPage() {
        return 0;
    }
    get maxPage() {
        return Math.max(Math.ceil(this.words.length / this.sizePerPage) - 1, 0);
    }
}
exports.SearchResult = SearchResult;
